(function(){
  if(window.__superBonsaiOrderContext)return;
  window.__superBonsaiOrderContext=true;

  function ensureInput(form,name,value){
    var input=form.querySelector('input[name="'+name+'"]');
    if(!input){
      input=document.createElement('input');
      input.type='hidden';
      input.name=name;
      form.appendChild(input);
    }
    input.value=value;
  }

  function apply(root){
    if(!document.body.classList.contains('template-product--superbonsai'))return;
    (root||document).querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function(form){
      ensureInput(form,'properties[_commerce_brand]','superbonsai');
      ensureInput(form,'properties[_commerce_host]',window.location.host);
      ensureInput(form,'properties[_commerce_locale]',(document.documentElement.lang||'en').toLowerCase());
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){apply(document)});else apply(document);
  document.addEventListener('shopify:section:load',function(event){apply(event.target)});
})();